import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const ModernCard = styled(Card)(({ theme, color = 'primary' }) => ({
  background: `linear-gradient(135deg, 
    ${theme.palette.background.paper} 0%, 
    ${theme.palette.grey[50]} 100%)`,
  borderRadius: 16,
  border: `1px solid ${
    color === 'primary' ? 'rgba(94, 86, 79, 0.24)' :
    color === 'success' ? 'rgba(82, 129, 90, 0.24)' :
    color === 'warning' ? 'rgba(166, 124, 82, 0.26)' :
    color === 'info' ? 'rgba(117, 130, 140, 0.24)' :
    'rgba(94, 86, 79, 0.24)'
  }`,
  position: 'relative',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  cursor: 'pointer',
  minHeight: 140,
  willChange: 'transform',
  
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: `0px 8px 24px rgba(0, 0, 0, 0.12), 
                0px 0px 16px ${
                  color === 'primary' ? 'rgba(94, 86, 79, 0.2)' :
                  color === 'success' ? 'rgba(82, 129, 90, 0.2)' :
                  color === 'warning' ? 'rgba(166, 124, 82, 0.22)' :
                  color === 'info' ? 'rgba(117, 130, 140, 0.2)' :
                  'rgba(94, 86, 79, 0.2)'
                }`,
  },
}));

const GlowingIcon = styled(Box)(({ theme, color = 'primary' }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 56,
  height: 56,
  borderRadius: 12,
  background: color === 'primary' ? '#5E564F' :
              color === 'success' ? '#52815A' :
              color === 'warning' ? '#A67C52' :
              color === 'info' ? '#75828C' :
              '#5E564F',
  boxShadow: `0px 4px 12px ${
    color === 'primary' ? 'rgba(94, 86, 79, 0.25)' :
    color === 'success' ? 'rgba(82, 129, 90, 0.25)' :
    color === 'warning' ? 'rgba(166, 124, 82, 0.25)' :
    color === 'info' ? 'rgba(117, 130, 140, 0.25)' :
    'rgba(94, 86, 79, 0.25)'
  }`,
  
  '& .MuiSvgIcon-root': {
    fontSize: '1.75rem',
    color: '#ffffff',
  },
}));

const StatsCard = ({ 
  title, 
  value, 
  icon, 
  color = 'primary', 
  onClick,
  trend,
  subtitle
}) => {
  return (
    <ModernCard color={color} onClick={onClick}>
      <CardContent sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box display="flex" alignItems="flex-start" justifyContent="space-between" mb={2}>
          <Box flex={1}>
            <Typography 
              variant="h6" 
              sx={{ 
                mb: 1,
                  color: color === 'primary' ? '#5E564F' :
                      color === 'success' ? '#3E6A45' :
                      color === 'warning' ? '#8B6A45' :
                      color === 'info' ? '#5F6C76' :
                    '#5E564F',
                fontWeight: 700,
                fontSize: '0.95rem',
                textShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)'
              }}
            >
              {title}
            </Typography>
            <Typography 
              variant="h3" 
              sx={{ 
                fontWeight: 800,
                color: '#2F2F2F',
                textShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                mb: 0.5
              }}
            >
              {value}
            </Typography>
            {subtitle && (
              <Typography 
                variant="body2" 
                sx={{ 
                  fontSize: '0.85rem',
                  color: '#6F6F6F',
                  fontWeight: 500
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
          
          <GlowingIcon color={color}>
            {icon}
          </GlowingIcon>
        </Box>
        
        {trend && (
          <Box 
            sx={{ 
              mt: 'auto',
              pt: 2,
              borderTop: '1px solid rgba(139, 115, 85, 0.1)' 
            }}
          >
            <Typography 
              variant="body2" 
              sx={{ 
                color: trend.positive ? '#4caf50' : '#f44336',
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                gap: 0.5
              }}
            >
              {trend.icon} {trend.text}
            </Typography>
          </Box>
        )}
      </CardContent>
    </ModernCard>
  );
};

export default StatsCard;